// extracted by mini-css-extract-plugin
export default {"container":"Aba-z","oos":"Bba-z","oosUx":"Cba-z","selected":"Dba-z","labelOos":"Eba-z"};